import Phaser from 'phaser';
import { CONTRACT_VENDORED, getFixture, listFixturePaths } from '../../contract/loadContract';
import { selectFixturePath } from '../../contract/selectFixture';
import type { ContractFixtureEnvelope } from '../../contract/types';
import { getSpriteManifest } from '../../assets/loadAssets';
import { parseSessionConfigFromLocation } from '../world/sessionConfig';
import { loadWorldState } from '../world/worldStorage';
import { BOOT_SCENE_KEY, HUD_SCENE_KEY, WORLD_SCENE_KEY } from '../sceneKeys';
import type { WorldSceneData } from './WorldScene';
import type { HudSceneData } from './HudScene';

/**
 * CP21 boot scene: preloads the placeholder-art sprites, resolves the
 * dev-harness session config from the URL query string (see
 * `world/sessionConfig.ts`), picks a vendored contract fixture, loads the
 * persisted local world state, then starts WorldScene and launches
 * HudScene alongside it (a second, parallel scene - Phaser's standard
 * multi-scene HUD pattern).
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super(BOOT_SCENE_KEY);
  }

  preload(): void {
    const sprites = getSpriteManifest();
    for (const sprite of Object.values(sprites)) {
      this.load.svg(sprite.key, sprite.url, { width: sprite.width, height: sprite.height });
    }
  }

  create(): void {
    const sessionConfig = parseSessionConfigFromLocation(window.location.search);
    const fixturePaths = listFixturePaths();
    const chosenPath = selectFixturePath(fixturePaths, sessionConfig.fixturePath);
    const fixture: ContractFixtureEnvelope | undefined = chosenPath ? getFixture(chosenPath) : undefined;
    const worldState = loadWorldState(window.localStorage);

    const worldSceneData: WorldSceneData = fixture
      ? { contractVendored: CONTRACT_VENDORED, fixture, sessionConfig, worldState }
      : { contractVendored: CONTRACT_VENDORED, sessionConfig, worldState };
    const hudSceneData: HudSceneData = fixture
      ? { contractVendored: CONTRACT_VENDORED, fixture, sessionConfig }
      : { contractVendored: CONTRACT_VENDORED, sessionConfig };

    this.scene.start(WORLD_SCENE_KEY, worldSceneData);
    this.scene.launch(HUD_SCENE_KEY, hudSceneData);
  }
}
